'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider');
const Carousel = require('../../shared/views/carousel');
const CarouselV2 = require('../../../components/carousel');
const CouponsGrid = require('../../coupons/views/coupons-grid');
const CouponsGridV2 = require('../../coupons/views/coupons-grid-v2');
const CouponsCategoryTabs = require('../../coupons/views/coupons-category-tabs');
const CtaTopOffers = require('../../coupons/views/cta-top-offers');
const MerchantLinks = require('../../merchant/views/merchant-links');
const FavoriteMerchants = require('../../merchant/views/favorite-merchants');
const EmailSubscription = require('../../email_subscription/views/email-subscription');
const RichText = require('../../shared/views/rich-text');
const LeaderboardCallout = require('../../shared/views/leaderboard-callout');
const { pruneData } = require('../../support/prune-data.js');

const minCouponsForCarousel = 4;

function getCarouselOptions(coupons) {
  return {
    className: 'carousel-hero',
    coupons,
    autoplay: true,
    navigation: true,
    options: {
      perPage: {
        1: 1,
        375: 2,
        767: 3,
        991: 4,
      },
    },
  };
}

function Home({ payload, deps }) {
  const {
    keyAuthData,
    categoryData,
    navigationMerchants,
    advertsForCarousel,
    couponsForGrid,
    couponsForTabs,
    homeMerchants,
    favoriteMerchants,
    leaderboardAdverts,
  } = payload;
  const {
    routes,
    showFavoriteMerchants,
    showNewCarousel,
    isTouch,
    showEmailSubscription,
    csrfToken,
    showTopCoupons,
    showSeoContent,
    showLeaderboardBanner,
    showLeaderboardCallout,
  } = deps;

  return h('article', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      activePage: 'home',
      keyAuthData,
      merchants: navigationMerchants,
    }),
    h('.page-container', [
      advertsForCarousel &&
        advertsForCarousel.length >= minCouponsForCarousel &&
        h(
          '.row',
          h(
            '.twelve.columns',
            !showNewCarousel
              ? h(
                  '.carousel-container',
                  h(Carousel, {
                    routes,
                    ...getCarouselOptions(advertsForCarousel),
                  })
                )
              : CarouselV2({
                  routes: pruneData(routes, 'merchant:show'),
                  items: advertsForCarousel,
                  widgetName: 'CouponsCarousel',
                  isTouch,
                })
          )
        ),
      LeaderboardCallout({
        display: showLeaderboardCallout,
        adverts: leaderboardAdverts,
        isTouch,
      }),
      showFavoriteMerchants &&
        h(
          '.row',
          h(
            '.twelve.columns',
            FavoriteMerchants({
              merchants: favoriteMerchants,
              routes: pruneData(routes, 'merchant:show'),
              show: showFavoriteMerchants,
            })
          )
        ),
    ]),
    !showTopCoupons
      ? h(
          '.row',
          h(
            '.twelve.columns',
            h(CouponsGrid, {
              coupons: couponsForGrid,
              routes,
              showTopCoupons,
              isTouch,
            })
          )
        )
      : h(CouponsGridV2, {
          items: couponsForGrid,
          routes,
          isTouch,
          showLeaderboardBanner,
          leaderboardAdverts,
          showSeoContent,
        }),
    h('.page-container', [
      showEmailSubscription &&
        h(
          '.row',
          h(
            '.twelve.columns',
            EmailSubscription({
              csrfToken,
              routes,
              classNames: {
                inner: 'email-subscription-full-width',
              },
              bhwName: 'EmailSubscription',
            })
          )
        ),
      h(
        '.row',
        h(
          '.twelve.columns',
          h(CouponsCategoryTabs, {
            keyAuthData,
            categoryData,
            coupons: couponsForTabs,
            routes,
          })
        )
      ),
      h(CtaTopOffers, { routes }),
      RichText({
        display: showSeoContent,
        sectionHeadingKey: 'modules.home.SecondarySeoHeading',
        richTextKey: 'modules.home.SecondarySeoText',
      }),
      h(
        '.row',
        h(
          '.twelve.columns',
          h(MerchantLinks, { routes, merchants: homeMerchants })
        )
      ),
    ]),
  ]);
}

module.exports = Home;
